document.addEventListener("DOMContentLoaded", function () {
	document.querySelector("body").classList.remove("no-scroll");
	let videos = document.querySelector(".prive-videos");
	videos.style.minHeight = videos.clientHeight + "px";
});

let listButtons = document.querySelectorAll(".prive-videos-list button");
let selectorButton = document.querySelector(".prive-videos-selector-button");
let selector = document.querySelector(".prive-videos-list");

[...listButtons].map((button) => {
	button.addEventListener("click", function () {
		[...listButtons].map((button) => button.classList.remove("active"));

		button.classList.add("active");
		let group = button.dataset.videoGroup;

		let cardsHide = document.querySelectorAll(".prive-video-card");
		// [...cardsHide].map((card) => card.classList.remove("active"));
		[...cardsHide].map((card) =>
			gsap.to(card, {
				autoAlpha: 0,
				onComplete: () => {
					card.classList.remove("active");

					let cards = document.querySelectorAll(
						'.prive-video-card[data-video-group="' + group + '"]'
					);
					// [...cards].map((card) => card.classList.add("active"));
					[...cards].map((card) =>
						gsap.fromTo(
							card,
							{
								autoAlpha: 0,
							},
							{
								autoAlpha: 1,
								// stagger: 0.1,
								onStart: () => card.classList.add("active"),
							}
						)
					);

					selector.classList.remove("open");

					selectorButton.innerHTML = button.innerHTML;
				},
			})
		);
	});
});

if (selectorButton != null) {
	selectorButton.addEventListener("click", function () {
		selector.classList.toggle("open");
	});
}

var buttons = document.querySelectorAll(".prive-form-button-inner");

for (var i = 0; i < buttons.length; i++) {
	buttons[i].addEventListener("click", function () {
		var content = this.nextElementSibling;

		if (content.style.maxHeight) {
			content.style.maxHeight = null;
			content.classList.remove("open");
		} else {
			content.style.maxHeight = content.scrollHeight + 32 + "px";
			content.classList.add("open");
		}
	});
}

// gsap.to(".prive-footer-curve", {
// 	height: 0,
// 	scrollTrigger: {
// 		trigger: ".prive-footer",
// 		start: "top 75%",
// 		end: "top 55%",
// 		scrub: true,
// 		// markers: true,
// 	},
// });

// Loader
const video = document.getElementById("prive-hero-video");

if (video) {
	video.onloadedmetadata = function () {
		// Video is ready to play
		console.log("Video is ready to play");
		// Call your function here
		hideLoader(); // Replace 'hideLoader' with the function you want to call
	};
}

function hideLoader() {
	gsap.to(".prive-loader", { autoAlpha: 0 });

	// Animations

	let heroHeight = window.innerWidth < 992 ? 50 : 60;
	let curveHeight = window.innerWidth < 992 ? 2 : 6;
	let titlePosition = window.innerWidth < 992 ? "50%" : 0;
	let delay = 2;

	gsap.timeline({ defaults: { duration: 1 }, onComplete: () => priveInit() })
		.fromTo(
			".prive-hero",
			{
				height: "100vh",
			},
			{
				height: heroHeight + "vh",
			},
			delay
		)
		.fromTo(
			".prive-hero .prive-hero-title",
			{
				bottom: "50%",
				y: "50%",
			},
			{
				bottom: titlePosition,
				y: 0,
				ease: "power.out4",
			},
			delay
		)
		.fromTo(
			".prive-hero-curve",
			{
				height: "0",
			},
			{
				height: curveHeight + "rem",
			},
			delay
		)
		.from(
			":not(.prive-features-wrapper) .prive-container",
			{
				y: "40vh",
				ease: "power1.out",
				opacity: 0,
			},
			"-=.25"
		);

	function priveInit() {
		gsap.to(".prive-hero-media", {
			y: "25%",
			scrollTrigger: {
				trigger: ".prive-hero-media",
				start: "top top",
				end: "bottom top",
				scrub: true,
				// markers: true,
			},
		});

		gsap.to(".prive-hero-curve", {
			height: 0,
			ease: "none",
			scrollTrigger: {
				trigger: "body",
				start: "top top",
				endTrigger: ".prive-hero",
				end: "bottom top",
				scrub: true,
				// markers: true,
			},
		});

		ScrollTrigger.batch(".prive-feature", {
			start: "top 75%",
			onEnter: (elements, triggers) => {
				gsap.to(elements, { opacity: 1, stagger: 0.25, duration: 2 });
			},
		});
	}
}

gsap.to(".prive-footer video", {
	y: "-20%",
	scrollTrigger: {
		trigger: ".prive-footer",
		start: "top bottom",
		end: "bottom top",
		scrub: true,
		// markers: true,
	},
});

// var sheet = new CSSStyleSheet();
// sheet.replaceSync(`._formSubmitButton_g1wk8_82 { color: red !important }`);
// host.shadowRoot.adoptedStyleSheets.push(sheet);

// document.querySelector("._formSubmitButton_g1wk8_82").style.backgroundColor =
// 	"blue";

// //host is the element that holds the shadow root:
// var style = document.createElement("style");
// style.innerHTML = "._formSubmitButton_g1wk8_82 { color: purple; }";
// host.shadowRoot.appendChild(style);

// // Create an empty "constructed" stylesheet
// let sheet = new CSSStyleSheet();
// // Apply a rule to the sheet
// sheet.insertRule(":host { background-color: red; }");

setTimeout(function () {
	const host = document.querySelector("#app-embed");
	// const shadow = host.attachShadow({ mode: "open" });
	const shadow = host.shadowRoot;
	const template = document.getElementById("my-element");

	shadow.appendChild(template.content);
}, 2000);
